import { trackGAEvent } from '@moonpig/web-core-analytics'

export const useProductDetailsAccordionTracking = (
  productId: string,
  selectedKeys: string[],
  setSelectedKeys: (keys: string[]) => void,
) => {
  const onSelect = (keys: string[]) => {
    const closedKeys = selectedKeys.filter(key => !keys.includes(key))
    const openedKeys = keys.filter(key => !selectedKeys.includes(key))

    openedKeys.forEach(key => {
      trackGAEvent({
        content_data: {
          content_type: `product details | ${productId} | accordion | ${key} | open`,
        },
        ecommerce: undefined,
        error_data: undefined,
        event: 'select_content',
        event_data: {
          action: 'view item',
          category: 'product details',
          label: `product details | ${productId} | accordion | ${key} | open`,
          non_interaction: true,
          value: undefined,
        },
      })
    })

    closedKeys.forEach(key => {
      trackGAEvent({
        content_data: {
          content_type: `product details | ${productId} | accordion | ${key} | close`,
        },
        ecommerce: undefined,
        error_data: undefined,
        event: 'select_content',
        event_data: {
          action: 'view item',
          category: 'product details',
          label: `product details | ${productId} | accordion | ${key} | close`,
          non_interaction: true,
          value: undefined,
        },
      })
    })

    setSelectedKeys(keys)
  }

  return { onSelect }
}
